import { render, staticRenderFns } from "./accessControl.vue?vue&type=template&id=5d4abe53&scoped=true&"
import script from "./accessControl.vue?vue&type=script&lang=js&"
export * from "./accessControl.vue?vue&type=script&lang=js&"
import style0 from "./accessControl.vue?vue&type=style&index=0&id=5d4abe53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4abe53",
  null
  
)

export default component.exports